import { useEffect } from 'react';
import { FaHome, FaAngleDoubleLeft, FaAngleLeft, FaAngleRight, FaAngleDoubleRight, FaFileExcel, FaFilePdf } from 'react-icons/fa';
import $ from 'jquery';
import styled from 'styled-components';
import AllenBradley from '../../Tables/Tabledata/OEMMaintenance/Allen Bradley/1756-um543_-en-p.pdf';
import AlliedVision from '../../Tables/Tabledata/OEMMaintenance/AlliedVision/Alvium-USB-Cameras_User-Guide 235 Pages.pdf';
import Fuji from '../../Tables/Tabledata/OEMMaintenance/Fuji/HF-XA-5M_OperationManual 2 Pages.pdf';

const TableComp = ({ className, tablesorter }) => {
	useEffect(() => {
		$('#myTable')
			.tablesorter({
				theme: 'ice',
				widgets: ['filter', 'zebra', 'cssStickyHeaders', 'pager'],
				widgetOptions: { cssStickyHeaders_attachTo: '.table-container', uitheme: 'jui' },
			})
			.tablesorterPager({
				// target the pager markup - see the HTML block below
				container: $('.pager'),

				// output string - default is '{page}/{totalPages}';
				// possible variables:
				// {page}, {totalPages}, {startRow}, {endRow} and {totalRows}
				output: '{page}/{totalPages} ({startRow}-{endRow})',

				// apply disabled classname to the pager arrows when the rows at
				// either extreme is visible - default is true
				updateArrows: true,

				// starting page of the pager (zero based index)
				page: 0,

				// Number of visible rows - default is 10
				size: 12,

				// if true, the table will remain the same height no matter how many
				// records are displayed. The space is made up by an empty
				// table row set to a height to compensate; default is false
				fixedHeight: true,

				// remove rows from the table to speed up the sort of large tables.
				// setting this to false, only hides the non-visible rows; needed
				// if you plan to add/remove rows with the pager enabled.
				removeRows: false,

				// css class names of pager arrows
				// next page arrow
				cssNext: '.next',
				// previous page arrow
				cssPrev: '.prev',
				// go to first page arrow
				cssFirst: '.first',
				// go to last page arrow
				cssLast: '.last',
				// select dropdown to allow choosing a page
				cssGoto: '.gotoPage',
				// location of where the "output" is displayed
				cssPageDisplay: '.pagedisplay',
				// dropdown that sets the "size" option
				cssPageSize: '.pagesize',
				// class added to arrows when at the extremes
				// (i.e. prev/first arrows are "disabled" when on the first page)
				// Note there is no period "." in front of this class name
				cssDisabled: 'disabled',
			});
	});
	let classes = { className };
	if (tablesorter) {
		classes += 'tablesorter';
	}

	return (
		<table id="myTable" class={classes} style={{ width: '100%' }}>
			<thead>
				<tr>
					<th>Manufacturer</th>
					<th>Document File Name</th>
					<th>Document Description</th>
					<th>Section / Page</th>
					<th>File</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td>Allen Bradley</td>
					<td>GuardLogix Controller User Manual.pdf</td>
					<td>GuardLogix Controllers User Manual</td>
					<td>Appendix A – Status Indicators Page 205</td>
					<td>
						<a href={AllenBradley} target="_blank">
							<FaFilePdf size={50} color={'grey'} class="file-link" />
						</a>
					</td>
				</tr>
				<tr>
					<td>Allied Vision</td>
					<td>Nano-5G_Series_User 229 Pages.pdf</td>
					<td>Genie Nano-5G Series™ Camera User’s Manual, 5 Gb GigE Vision – Monochrome & Color Area Scan</td>
					<td>Cleaning the Sensor Window Page 199</td>
					<td>
						<a href={AlliedVision} target="_blank">
							<FaFilePdf size={50} class="file-link pdf" />
						</a>
					</td>
				</tr>
				<tr>
					<td>Fuji Film</td>
					<td>HF-XA-5M_OperationManual 2 Pages.pdf</td>
					<td>Fujinon Lens Operation Manual</td>
					<td>Cleaning of Lens Page 1</td>
					<td>
						<a href={Fuji} target="_blank">
							<FaFilePdf size={50} class="file-link pdf" />
						</a>
					</td>
				</tr>
			</tbody>
			<tfooter id="pager" className="pager" style={{}}>
				<form>
					<FaAngleDoubleLeft size={30} style={{ color: '#000', margin: '.25rem .5rem' }} className="first" alt="button" />
					<FaAngleLeft size={30} style={{ color: '#000', margin: '.25rem .5rem' }} className="prev" alt="button" />
					<input type="text" className="pagedisplay" alt="button" />
					<FaAngleRight size={30} style={{ color: '#000', margin: '.25rem .5rem' }} className="next" alt="button" />
					<FaAngleDoubleRight size={30} style={{ color: '#000', margin: '.25rem .5rem' }} className="last" alt="button" />
					<select className="pagesize">
						<option selected="selected" value="12">
							12
						</option>
					</select>
				</form>
			</tfooter>
		</table>
	);
};

const OEMTable = styled(TableComp)``;

export default OEMTable;
